var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderInvite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23438 11.8135L12.0057 16.0183L19.777 11.8135V19.886H4.23438V11.8135Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0898 9.82617L18.0898 4.75369L6.04437 4.75369L6.04437 9.82617",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 10.1865H14.9611",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 7.29004V13.0832",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderInvite);
export default __webpack_public_path__ + "static/media/header-invite.0c9842f1f0a2c204493eadbab3d1fcdc.svg";
export { ForwardRef as ReactComponent };